// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__yqx7-","image":"Card_image__c6hwn","data":"Card_data__LcuVC","key":"Card_key__8Hsl+"};